export const locale = {
    lang: "en",
    data: {
      NAV: {
        NOTIFICATION: "Notification",
        NEW:"New"
      }
    }
  };
  